import { all, call, put, takeLatest } from '@redux-saga/core/effects';
import axios, { AxiosResponse } from 'axios';

import { SagaPayload } from '../api.types';
import { RegisterSystemUserRequest, RegisterSystemUserResponse } from './registration.types';

import { REGISTERING } from './registration.constants';

import { requestRegisterSystemUser } from './registration.actions';

import { getRegisterSystemUserRequest } from './registration.endpoints';

import { addSpinner, addSystemNotice, removeSpinner } from '../../slices/system/system.slice';

import { getErrorMessage } from '../../utils/api.util';
import { ERROR } from '../../utils/constants';

export function* performRegisterSystemUserRequest({ payload }: SagaPayload<RegisterSystemUserRequest, string>) {
  const { requestData, onSuccess } = payload;

  try {
    yield put(addSpinner(REGISTERING));

    const [endpoint, options] = getRegisterSystemUserRequest(requestData);

    const { data }: AxiosResponse<RegisterSystemUserResponse> = yield call(axios, endpoint, options);

    if (onSuccess) {
      yield call(onSuccess, data.programmeName);
    }
  } catch (error) {
    const message = getErrorMessage(error);
    yield put(addSystemNotice({ type: ERROR, message }));
  } finally {
    yield put(removeSpinner(REGISTERING));
  }
}

export function* watchForRegisterSystemUserRequest() {
  yield takeLatest(requestRegisterSystemUser.type, performRegisterSystemUserRequest);
}

export default function* registrationSaga() {
  yield all([watchForRegisterSystemUserRequest()]);
}
